/* =========================================================
   RAFFIN ART — JavaScript del tema (sin dependencias)
   ========================================================= */
(function () {
  'use strict';

  const R = window.RAFFIN || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

  /* ---------- Dinero ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || R.moneyFormat || '${{amount_no_decimals}}';
    const rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, dec, th, ds) {
      if (isNaN(n) || n == null) return '0';
      th = th === undefined ? ',' : th;
      ds = ds === undefined ? '.' : ds;
      const parts = (n / 100).toFixed(dec).split('.');
      const d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? ds + parts[1] : '');
    }
    const m = format.match(rx);
    let v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 0);
    }
    return format.replace(rx, v);
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Overlay / bloqueo de scroll ---------- */
  const overlay = $('[data-overlay]');
  let openStack = [];
  function lock() { document.body.classList.add('is-locked'); overlay && overlay.classList.add('is-visible'); }
  function unlock() { if (openStack.length) return; document.body.classList.remove('is-locked'); overlay && overlay.classList.remove('is-visible'); }

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (!openStack.includes(el)) openStack.push(el);
    lock();
    const f = el.querySelector('input:not([type=hidden]), button, a');
    if (f && !el.classList.contains('drawer')) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openStack = openStack.filter((x) => x !== el);
    unlock();
  }
  function closeAll() { openStack.slice().forEach(closePanel); }

  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Mueve drawers al body (evita problemas con el header fijo) ---------- */
  function hoistDrawers() {
    $$('.section-header .drawer, .section-header .bottom-nav').forEach((el) => {
      if (el.id) { const old = document.body.querySelector(':scope > #' + el.id); if (old && old !== el) old.remove(); }
      if (el.classList.contains('bottom-nav')) { const oldNav = document.body.querySelector(':scope > .bottom-nav'); if (oldNav && oldNav !== el) oldNav.remove(); }
      document.body.appendChild(el);
    });
  }

  /* ---------- Delegación de clics ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;

    const dOpen = t.closest('[data-drawer-open]');
    if (dOpen) { e.preventDefault(); openPanel(document.getElementById(dOpen.dataset.drawerOpen)); return; }

    const dClose = t.closest('[data-drawer-close]');
    if (dClose) { closePanel(dClose.closest('.drawer')); return; }

    const cOpen = t.closest('[data-cart-open]');
    if (cOpen && R.cartType === 'drawer' && $('#CartDrawer')) { e.preventDefault(); closeAll(); openPanel($('#CartDrawer')); return; }

    const sOpen = t.closest('[data-search-open]');
    if (sOpen) { e.preventDefault(); closeAll(); openPanel($('#SearchOverlay')); setTimeout(() => { const i = $('#SearchOverlay [data-predictive]'); i && i.focus(); }, 80); return; }

    const sClose = t.closest('[data-search-close]');
    if (sClose) { closePanel($('#SearchOverlay')); return; }

    const mOpen = t.closest('[data-modal-open]');
    if (mOpen) { e.preventDefault(); openPanel(document.getElementById(mOpen.dataset.modalOpen)); return; }

    const mClose = t.closest('[data-modal-close]');
    if (mClose) { closePanel(mClose.closest('.modal')); return; }

    if (t.classList && (t.classList.contains('modal') || t.classList.contains('popup'))) { closePanel(t); if (t.id === 'DiscountPopup') dismissPopup(); return; }

    const pClose = t.closest('[data-popup-close]');
    if (pClose) { closePanel($('#DiscountPopup')); dismissPopup(); return; }

    const copy = t.closest('[data-copy]');
    if (copy) {
      e.preventDefault();
      const code = copy.dataset.copy;
      const done = () => { copy.classList.add('is-copied'); toast('Cupón ' + code + ' copiado'); setTimeout(() => copy.classList.remove('is-copied'), 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      return;
    }

    const wish = t.closest('[data-wish]');
    if (wish) { e.preventDefault(); toggleWish(wish.dataset.wish); return; }

    const qtyChange = t.closest('[data-qty-change]');
    if (qtyChange) { e.preventDefault(); changeLine(+qtyChange.dataset.line, +qtyChange.dataset.qtyChange); return; }

    const qtyStep = t.closest('[data-qty-step]');
    if (qtyStep) {
      const input = qtyStep.parentElement.querySelector('input');
      if (input) {
        const min = input.min !== '' ? +input.min : 1;
        input.value = Math.max(min, (+input.value || 0) + (+qtyStep.dataset.qtyStep));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const lb = t.closest('[data-lightbox]');
    if (lb) { const box = $('[data-lightbox-box]'); if (box) { box.querySelector('img').src = lb.dataset.lightbox; openPanel(box); } return; }
    const lbClose = t.closest('[data-lightbox-close]') || (t.matches && t.matches('[data-lightbox-box]') ? t : null);
    if (lbClose) { closePanel($('[data-lightbox-box]')); return; }

    const sp = t.closest('[data-scroll-prev], [data-scroll-next]');
    if (sp) {
      const sec = sp.closest('.shopify-section') || document;
      const sc = sec.querySelector('[data-scroller]');
      if (sc) {
        const dir = sp.hasAttribute('data-scroll-next') ? 1 : -1;
        const item = sc.firstElementChild;
        const step = item ? item.getBoundingClientRect().width + 16 : sc.clientWidth * 0.8;
        sc.scrollBy({ left: dir * step * (window.innerWidth > 989 ? 2 : 1), behavior: 'smooth' });
      }
      return;
    }

    const toggleRecover = t.closest('[data-toggle-recover]');
    if (toggleRecover) { const a = $('#RecoverPassword'), b = $('#LoginPanel'); if (a && b) { a.hidden = !a.hidden; b.hidden = !b.hidden; } }
  });

  /* =========================================================
     CARRITO (AJAX)
     ========================================================= */
  function updateCounts(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = html.querySelector('#CartDrawerInner');
    const cur = $('#CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }

  async function refreshCount() {
    try { const c = await (await fetch(R.routes.cart + '.js')).json(); updateCounts(c.item_count); } catch (e) {}
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type=submit]') || document.querySelector('[form="' + form.id + '"]');
    const fd = new FormData(form);
    const hasDrawer = R.cartType === 'drawer' && $('#CartDrawer');
    if (hasDrawer) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
    btn && btn.classList.add('is-loading');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(R.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
      if (hasDrawer) { renderDrawer(data.sections); closeAll(); openPanel($('#CartDrawer')); }
      else { toast('¡Agregado al carrito!'); }
      refreshCount();
    } catch (err) {
      toast(err.message || 'No pudimos agregar este producto');
    } finally {
      btn && btn.classList.remove('is-loading');
      btn && btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  async function changeLine(line, quantity) {
    const drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-loading');
    try {
      const res = await fetch(R.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      renderDrawer(data.sections);
      updateCounts(data.item_count);
    } catch (err) { toast(err.message || 'No se pudo actualizar'); }
    finally { drawer && drawer.classList.remove('is-loading'); }
  }

  let noteTimer;
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-cart-note]')) {
      clearTimeout(noteTimer);
      const note = e.target.value;
      noteTimer = setTimeout(() => {
        fetch(R.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) });
      }, 500);
    }
  });

  let autoTimer;
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-autosubmit]')) {
      clearTimeout(autoTimer);
      const f = e.target.form;
      autoTimer = setTimeout(() => f && f.submit(), 600);
    }
    if (e.target.matches('[data-sort]')) e.target.form.submit();
  });

  /* =========================================================
     BÚSQUEDA PREDICTIVA
     ========================================================= */
  function initPredictive() {
    const input = $('#SearchOverlay [data-predictive]');
    const out = $('#SearchOverlay [data-predictive-results]');
    if (!input || !out) return;
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          ctrl && ctrl.abort();
          ctrl = new AbortController();
          const url = R.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const data = await (await fetch(url, { signal: ctrl.signal })).json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { out.innerHTML = '<p>No encontramos resultados para “' + escapeHtml(q) + '”.</p>'; return; }
          out.innerHTML = '<div class="predictive">' + items.map((p) =>
            '<a class="predictive__item" href="' + p.url + '">' +
              (p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span></span>') +
              '<span><span>' + escapeHtml(p.title) + '</span><br><span class="predictive__price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></span>' +
            '</a>').join('') + '</div>' +
            '<a class="predictive__all" href="' + R.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">Ver todos los resultados</a>';
        } catch (err) { /* abortado */ }
      }, 220);
    });
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  /* =========================================================
     ROTADOR DE ANUNCIOS
     ========================================================= */
  function initRotators(ctx) {
    $$('[data-rotator]', ctx).forEach((el) => {
      if (el._rot) clearInterval(el._rot);
      const items = $$('.announce__item', el);
      if (items.length < 2) return;
      let i = 0;
      el._rot = setInterval(() => {
        if (window.innerWidth >= 990) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, +el.dataset.interval || 4000);
    });
  }

  /* =========================================================
     SLIDER HERO
     ========================================================= */
  function initSliders(ctx) {
    $$('[data-slider]', ctx).forEach((root) => {
      const track = $('[data-slider-track]', root);
      const slides = $$('[data-slide]', root);
      const dots = $$('[data-slider-dots] button', root);
      if (!track || slides.length < 2) return;
      let idx = 0;
      const go = (n) => { idx = (n + slides.length) % slides.length; track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); };
      dots.forEach((d, n) => d.addEventListener('click', () => { go(n); restart(); }));
      const prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
      prev && prev.addEventListener('click', () => { go(idx - 1); restart(); });
      next && next.addEventListener('click', () => { go(idx + 1); restart(); });
      let st;
      track.addEventListener('scroll', () => {
        clearTimeout(st);
        st = setTimeout(() => {
          idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((d, n) => d.classList.toggle('is-active', n === idx));
        }, 60);
      }, { passive: true });
      const delay = +root.dataset.autoplay || 0;
      let timer;
      function restart() { clearInterval(timer); if (delay > 0 && !(window.Shopify && Shopify.designMode)) timer = setInterval(() => go(idx + 1), delay); }
      root.addEventListener('pointerenter', () => clearInterval(timer));
      root.addEventListener('pointerleave', restart);
      restart();
    });
  }

  /* =========================================================
     CONTADORES (fecha de fin de promoción)
     ========================================================= */
  function parseEnd(str) {
    if (!str) return null;
    const m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    const hh = (m[4] || '23').padStart(2, '0'), mm = m[5] || '59';
    return new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + hh + ':' + mm + ':00-05:00'); // Hora Colombia
  }
  const pad = (n) => String(n).padStart(2, '0');
  function initCountdowns(ctx) {
    $$('[data-countdown]', ctx).forEach((el) => {
      if (el._cd) clearInterval(el._cd);
      const end = parseEnd(el.dataset.end || R.promoEnd);
      if (!end || isNaN(end)) { el.classList.add('is-expired'); return; }
      const parts = { d: $('[data-cd-days]', el), h: $('[data-cd-hours]', el), m: $('[data-cd-minutes]', el), s: $('[data-cd-seconds]', el) };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        if (diff === 0) {
          clearInterval(el._cd);
          if (R.promoHideExpired) el.classList.add('is-expired');
        }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        parts.d && (parts.d.textContent = pad(d));
        parts.h && (parts.h.textContent = pad(h));
        parts.m && (parts.m.textContent = pad(m));
        parts.s && (parts.s.textContent = pad(s));
      };
      tick();
      el._cd = setInterval(tick, 1000);
    });
  }

  /* =========================================================
     ANIMACIONES + CIFRAS
     ========================================================= */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  const countIO = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target, to = +el.dataset.countTo || 0, dur = 1600, t0 = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e).toLocaleString('es-CO');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      countIO.unobserve(el);
    });
  }, { threshold: 0.4 }) : null;

  function initAnim(ctx) {
    $$('[data-anim]', ctx).forEach((el, i) => {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
    $$('[data-count-to]', ctx).forEach((el) => { if (countIO) countIO.observe(el); else el.textContent = el.dataset.countTo; });
  }

  /* =========================================================
     POPUP DE DESCUENTO
     ========================================================= */
  function dismissPopup() { store.set('raffin_popup', Date.now()); }
  function initPopup() {
    const pop = $('#DiscountPopup');
    if (!pop) return;
    if ($('[data-popup-open-now]', pop)) { openPanel(pop); dismissPopup(); return; }
    if (window.Shopify && Shopify.designMode) return;
    const last = store.get('raffin_popup', 0);
    if (last && Date.now() - last < 7 * 864e5) return;
    const delay = (+pop.dataset.delay || 0) * 1000;
    let shown = false;
    const show = () => { if (shown || openStack.length) return; shown = true; openPanel(pop); };
    setTimeout(show, delay);
    document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 10) show(); });
  }

  function initModalsAutoOpen() {
    $$('.modal').forEach((m) => { if ($('[data-modal-open-now]', m)) openPanel(m); });
  }

  /* =========================================================
     FAVORITOS
     ========================================================= */
  const WKEY = 'raffin_wishlist';
  function getWish() { return store.get(WKEY, []); }
  function paintWish() {
    const list = getWish();
    $$('[data-wish]').forEach((b) => {
      const on = list.includes(b.dataset.wish);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wish-count]').forEach((c) => { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  function toggleWish(handle) {
    let list = getWish();
    const on = list.includes(handle);
    list = on ? list.filter((h) => h !== handle) : [handle].concat(list).slice(0, 60);
    store.set(WKEY, list);
    paintWish();
    toast(on ? 'Quitado de favoritos' : 'Guardado en favoritos ♥');
    const grid = $('[data-wishlist-grid]');
    if (grid && on) { const card = grid.querySelector('[data-wish="' + handle + '"]'); card && card.closest('.card') && card.closest('.card').remove(); if (!getWish().length) { const em = $('[data-wishlist-empty]'); em && (em.hidden = false); } }
  }
  async function initWishlistPage() {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    const list = getWish();
    const empty = $('[data-wishlist-empty]');
    if (!list.length) { empty && (empty.hidden = false); return; }
    const htmls = await Promise.all(list.map(async (h) => {
      try {
        const res = await fetch(R.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=wish-card');
        if (!res.ok) return '';
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const card = doc.querySelector('.card');
        return card ? card.outerHTML : '';
      } catch (e) { return ''; }
    }));
    grid.innerHTML = htmls.join('');
    if (!grid.children.length) empty && (empty.hidden = false);
    paintWish();
    initAnim(grid);
  }

  /* =========================================================
     PÁGINA DE PRODUCTO
     ========================================================= */
  function initProduct(ctx) {
    $$('[data-product-section]', ctx).forEach((root) => {
      const vJson = $('[data-variants-json]', root);
      const cJson = $('[data-pdp-config]', root);
      const variants = vJson ? JSON.parse(vJson.textContent) : [];
      const cfg = cJson ? JSON.parse(cJson.textContent) : {};

      /* Galería */
      const main = $('[data-gallery-main]', root);
      const thumbs = $$('[data-thumb]', root);
      const slides = $$('.gallery__slide', root);
      function goMedia(id) {
        const s = slides.find((x) => x.dataset.mediaId == id);
        if (s && main) main.scrollTo({ left: slides.indexOf(s) * main.clientWidth, behavior: 'smooth' });
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb == id));
      }
      thumbs.forEach((t) => t.addEventListener('click', () => goMedia(t.dataset.thumb)));
      if (main) {
        let st;
        main.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => {
            const i = Math.round(main.scrollLeft / main.clientWidth);
            const s = slides[i];
            if (s) {
              thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb == s.dataset.mediaId));
              const at = thumbs.find((t) => t.classList.contains('is-active'));
              at && at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            }
          }, 80);
        }, { passive: true });
        if (window.matchMedia('(hover: hover)').matches) {
          main.addEventListener('click', (e) => { const img = e.target.closest('.gallery__slide img'); if (img) { const box = $('[data-lightbox-box]'); if (box) { box.querySelector('img').src = img.currentSrc || img.src; openPanel(box); } } });
        }
      }

      /* Variantes */
      const picker = $('[data-variant-picker]', root);
      const idInput = $('[data-variant-id]', root);
      function setText(sel, txt) { $$(sel, root).forEach((el) => { el.textContent = txt; }); }
      function update(v) {
        if (!v) {
          $$('[data-add-btn]', root).forEach((b) => { b.disabled = true; const l = b.querySelector('[data-add-label]'); l && (l.textContent = 'No disponible'); });
          return;
        }
        idInput && (idInput.value = v.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());

        const priceEl = $('[data-pdp-price]', root);
        if (priceEl) {
          const cur = $('[data-price]', priceEl), cmp = $('[data-compare]', priceEl), sv = $('[data-saving]', priceEl);
          cur && (cur.textContent = formatMoney(v.price));
          const onSale = v.compare > v.price;
          if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(v.compare) : ''; }
          if (sv) { sv.hidden = !onSale; sv.textContent = onSale ? '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : ''; }
          const tr = $('[data-transfer] strong', priceEl);
          tr && cfg.transfer && (tr.textContent = formatMoney(Math.floor(v.price * (100 - cfg.transfer) / 100)));
          const ins = $('[data-inst-amount]', priceEl);
          ins && cfg.installments && (ins.textContent = formatMoney(Math.floor(v.price / cfg.installments)));
        }
        cfg.transfer && setText('[data-pay-transfer]', formatMoney(Math.floor(v.price * (100 - cfg.transfer) / 100)));
        cfg.installments && setText('[data-pay-inst]', formatMoney(Math.floor(v.price / cfg.installments)));
        setText('[data-sticky-price]', formatMoney(v.price));

        $$('[data-add-btn]', root).forEach((b) => {
          b.disabled = !v.available;
          const l = b.querySelector('[data-add-label]');
          if (l) l.textContent = v.available ? (b.closest('.sticky-atc') ? 'Comprar ahora' : (cfg.addLabel || 'Agregar al carrito')) : 'Agotado';
        });

        const low = $('[data-low-stock]', root);
        if (low) {
          const show = cfg.lowStock > 0 && v.inv !== null && v.inv > 0 && v.inv <= cfg.lowStock;
          low.classList.toggle('is-hidden', !show);
          const n = $('[data-low-stock-n]', low); n && (n.textContent = v.inv);
        }
        if (v.media) goMedia(v.media);
      }
      if (picker) {
        picker.addEventListener('change', (e) => {
          const r = e.target;
          if (r.dataset.optionIndex !== undefined) setText('[data-option-label="' + r.dataset.optionIndex + '"]', r.value);
          const sel = $$('fieldset', picker).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
          update(variants.find((v) => v.options.every((o, i) => o === sel[i])));
        });
      }

      /* Barra fija de compra */
      const sticky = $('[data-sticky-atc]', root);
      const buyForm = $('.buy__form', root);
      if (sticky && buyForm && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        }).observe(buyForm);
      }

      /* Entrega estimada */
      $$('[data-delivery]', root).forEach(initDelivery);
    });
  }

  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function initDelivery(el) {
    const min = +el.dataset.min || 2, max = +el.dataset.max || 5, cutoff = +el.dataset.cutoff || 0;
    const now = new Date();
    let start = new Date(now);
    const wd = now.getDay();
    if ((cutoff && now.getHours() >= cutoff) || wd === 0 || wd === 6) start = addBusinessDays(now, 1);
    const fmt = new Intl.DateTimeFormat('es-CO', { weekday: 'short', day: 'numeric', month: 'short' });
    const from = $('[data-delivery-from]', el), to = $('[data-delivery-to]', el);
    from && (from.textContent = fmt.format(addBusinessDays(start, min)));
    to && (to.textContent = fmt.format(addBusinessDays(start, max)));
    const cut = $('[data-delivery-cutoff]', el), left = $('[data-delivery-left]', el);
    if (cut && left && cutoff && wd !== 0 && wd !== 6 && now.getHours() < cutoff) {
      const tick = () => {
        const n = new Date(), end = new Date(n); end.setHours(cutoff, 0, 0, 0);
        const diff = end - n;
        if (diff <= 0) { cut.hidden = true; return; }
        const h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4);
        left.textContent = (h ? h + ' h ' : '') + m + ' min';
        cut.hidden = false;
      };
      tick();
      setInterval(tick, 30000);
    }
  }

  /* ---------- Recomendaciones ---------- */
  function initRecommendations(ctx) {
    $$('[data-recommendations]', ctx).forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) { el.innerHTML = fresh.innerHTML; paintWish(); initAnim(el); }
      } catch (e) {}
    });
  }

  /* ---------- Encabezado con sombra al hacer scroll ---------- */
  function initHeaderScroll() {
    const h = $('[data-header]');
    if (!h) return;
    const on = () => h.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  /* =========================================================
     INICIO
     ========================================================= */
  function initAll(ctx) {
    initRotators(ctx);
    initSliders(ctx);
    initCountdowns(ctx);
    initAnim(ctx);
    initProduct(ctx);
    initRecommendations(ctx);
    paintWish();
  }

  function boot() {
    hoistDrawers();
    initAll(document);
    initPredictive();
    initPopup();
    initModalsAutoOpen();
    initWishlistPage();
    initHeaderScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Editor de temas */
  document.addEventListener('shopify:section:load', (e) => { hoistDrawers(); initAll(e.target); });
  document.addEventListener('shopify:section:select', (e) => {
    const pop = $('#DiscountPopup');
    if (pop && e.target.contains(pop)) openPanel(pop);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-slide]');
    if (slide) { const tr = slide.parentElement; tr && tr.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
  });
})();
